import React from 'react';
import { Link } from 'react-router-dom';
import { Home } from 'lucide-react';
import Magnetic from './Magnetic';
import TextReveal from './TextReveal';
import './Error404.css';

const Error404 = () => {
  return (
    <main className="error-404">
      <div className="error-404__glow" aria-hidden="true" />
      <div className="container error-404__inner">
        <TextReveal
          as="div"
          className="error-404__code gradient-text gradient-text--animated"
          text="404"
          mode="chars"
        />
        <TextReveal as="h1" className="error-404__title" text="Page not found" mode="words" delay={0.2} />
        <p className="error-404__text">
          This route doesn't exist. Let's get you back to something that works.
        </p>
        <Magnetic strength={0.25}>
          <Link to="/" className="btn btn-primary">
            <Home size={18} /> Back home
          </Link>
        </Magnetic>
      </div>
    </main>
  );
};

export default Error404;
